import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const ComaDetails = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const state = useSelector((state: ReducerState) => state);

  const {selectedPlan, selectedProduct} = state.quoteForm;
  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex || 0, 0);

  const productCd = selectedProduct?.code ?? '';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'coma-details-row-1'},
      items: [
        {
          key: propertyPaths.comaDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.comaDetails.incurralPeriod)}
              disabled
              required
              id={propertyPaths.comaDetails.incurralPeriod}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.comaDetails.waitingPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Duration (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.comaDetails.waitingPeriod)}
              disabled
              id={propertyPaths.comaDetails.waitingPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'coma-details-row-2'},
      items: [
        {
          key: propertyPaths.comaDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.comaDetails.customizeBenefitAmount)}
              id={propertyPaths.comaDetails.customizeBenefitAmount}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.comaDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.comaDetails.benefitAmount))}
              disabled
              required
              adornment="money"
              id={propertyPaths.comaDetails.benefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'coma-details-row-3'},
      items: [
        {
          key: propertyPaths.comaDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`${productCd}ComaBenefit.maxBenefitNumber`}
              disabled
              required
              value={getQuoteFieldValue<number>(propertyPaths.comaDetails.maxBenefitNumber)}
              id={propertyPaths.comaDetails.maxBenefitNumber}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.comaDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period"
              searchKey={`${productCd}ComaBenefit.timePeriodCd`}
              disabled
              required
              value={getQuoteFieldValue<number>(propertyPaths.comaDetails.timePeriodCd)}
              id={propertyPaths.comaDetails.timePeriodCd}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
